export default {"src":"/_next/static/image/public/images/flags/flag_212.bae391b622fc577677d4620db4ed2b22.svg","height":16,"width":24};